var _g, _circle, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1514_16453)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.5046,
    cy: 25.5046,
    r: 25.5046,
    fill: "url(#paint0_linear_1514_16453)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5046,
    cy: 25.5046,
    r: 22.3165,
    stroke: "url(#paint1_linear_1514_16453)",
    strokeWidth: 6.37615
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1514_16453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7963 36.9814C23.7115 36.9814 23.6275 36.9632 23.5498 36.9281C23.472 36.893 23.4022 36.8417 23.3446 36.7774L11.1635 23.1792C11.0823 23.0885 11.0284 22.9754 11.0085 22.8537C10.9887 22.7319 11.0036 22.6069 11.0516 22.4938C11.0995 22.3807 11.1784 22.2844 11.2785 22.2168C11.3786 22.1493 11.4956 22.1133 11.6152 22.1133H17.4785C17.5666 22.1133 17.6536 22.1328 17.7337 22.1704C17.8138 22.2081 17.8852 22.2631 17.9429 22.3316L22.0139 27.165C22.4539 26.1945 23.3056 24.5784 24.8001 22.6092C27.0096 19.698 31.1193 15.4166 38.1506 11.5516C38.2865 11.4769 38.4446 11.4575 38.5937 11.4972C38.7428 11.537 38.872 11.633 38.9558 11.7662C39.0397 11.8995 39.072 12.0604 39.0466 12.2171C39.0211 12.3738 38.9396 12.515 38.8182 12.6127C38.7913 12.6343 36.0803 14.8376 32.9603 18.8732C30.0888 22.5869 26.2717 28.6595 24.3934 36.4991C24.3604 36.6368 24.2836 36.7592 24.1754 36.8466C24.0671 36.9341 23.9336 36.9816 23.7961 36.9816L23.7963 36.9814Z",
    fill: "url(#paint2_linear_1514_16453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6378 22.751C11.6378 22.7509 11.6378 22.7509 11.6378 22.7509H17.4624L21.5262 27.5758L22.1773 28.3489L22.5946 27.4283C23.0167 26.4972 23.8446 24.9228 25.308 22.9947L24.8001 22.6092L25.308 22.9947C27.4579 20.162 31.4731 15.9685 38.3595 12.1645C37.9427 12.5116 35.3737 14.7091 32.4558 18.4832C29.554 22.2362 25.6919 28.3757 23.7828 36.311L11.6388 22.7543C11.6386 22.7539 11.6381 22.7529 11.6378 22.751Z",
    stroke: "url(#paint3_linear_1514_16453)",
    strokeWidth: 1.27523
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1514_16453",
    x: 0,
    y: 0,
    width: 51.0088,
    height: 54.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.69781
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.494118 0 0 0 0 0.298039 0 0 0 0 0.0352941 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1514_16453"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1514_16453",
    x: 5.89908,
    y: 11.4771,
    width: 38.2565,
    height: 35.7065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.10092
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.55046
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1514_16453"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1514_16453",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1514_16453",
    x1: 27.5325,
    y1: -4.51644,
    x2: 27.5325,
    y2: 51.0092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC1B20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1514_16453",
    x1: 42.7374,
    y1: 61.1411,
    x2: 42.7374,
    y2: -5.93943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.160417,
    stopColor: "#F8D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707292,
    stopColor: "#D09131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816667,
    stopColor: "#F8D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1514_16453",
    x1: 34.5056,
    y1: 42.0476,
    x2: 34.5056,
    y2: 8.50734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342708,
    stopColor: "#F8D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644792,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816667,
    stopColor: "#F8D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1514_16453",
    x1: 34.5056,
    y1: 42.0476,
    x2: 34.5056,
    y2: 8.50734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342708,
    stopColor: "#F8D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644792,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816667,
    stopColor: "#F8D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCheck);
export default __webpack_public_path__ + "static/media/ico-check.711a12db2875798d9de2864ae29c5749.svg";
export { ForwardRef as ReactComponent };